var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var actions = require( '../../../modules/education/actions/bodyPart' );
var educationActions = require( '../../../modules/education/actions/education');
var BodyPart = require('../components/bodypart.jsx');

  BodyPart.fetchData = function(query, params, store, history) {
    return store.dispatch(actions.fetchBodyPartIfNeeded(params.name));
  }

  var mapStateToProps = function(state){
    return {
      auth: state.auth,
      bodyPart:state.bodyPart
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, actions, educationActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(BodyPart);



// WEBPACK FOOTER //
// ./src/common/routes/education/containers/bodypart.jsx